import './wgg/styles.scss';
import './wgg/WggController.controller'

import './components/map/map.component';




// WEBPACK FOOTER //
// ./src/index.js